<div class="container mt-4">
  <a class="back-btn text-danger d-flex align-items-center mb-3 cursor-pointer" [routerLink]="['/ticketTransfer']">
    <i class="material-icons">chevron_left</i>
    <span class="fw-bold font-size-14">{{ 'tickets.page.back.button' | translate }}</span>
  </a>
  <fgbcl-ticket-selection-list />
</div>
